const cartNote = document.querySelector('#CartOrderNote')

cartNote.addEventListener('change', function(params) {
  console.log(params)
  var t = JSON.stringify({
            note: params.target.value
          });
          fetch(`${routes.cart_update_url}`, {
            ...{
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            body: t,
          })
            .then((t) => t.json())
            .then((t) => {
              console.log(t);
            })
            .catch((t) => {
              console.error(t);
            });
})